const info = {
  ZH: {
    //中文翻译
    addGUOnei: "添加国内快递单号",
    shuru: "输入多个单号请用逗号（,）空格或换行隔开",
    zidong: "系统会自动去除重复或者空格",
    qing: "清空",
    add: "添加包裹",
    addRe: "添加备注",
    qingshuru: "请输入备注",
    qudiao: "去掉多余包装",
    baoliu: "保留原包装",
    haopin: "去掉包裹好评",
    jiyun: "集运",
    qingbaoguo: "请输入包裹号",
    allPa: "全部包裹",
    TObe: "未签收",
    yiruku: "已签收",
    yijiyun: "已集运",
    overduePackage: "超期包裹",
    addTime: "添加时间",
    beizhu: "备注",
    xuanz: "已选中",
    bg: "包裹",
    gos: "去集运",
    dingdan: "我的订单",
    qdanhao: "请输入单号",
    daidab: "待打包",
    YZF: "已支付",
    DZF: "待支付",
    YCK: "已出库",
    YQS: "已签收",
    nonum: "暂无数据",
    orders: "订单号",
    zhuan: "转单号",
    zhong: "重量",
    volume: "材积",
    zongzhong: "总重量",
    xiubeizhu: "备注(修改)",
    guojia: "国家",
    yunshu: "运输方式",
    jiage: "价格",
    shijian: "时间",
    quxiaodingdan: "取消",
    zhiF: "去支付",
    zhuandanhao: "转单号",
    jifeiyong: "计费重",
    chukushijian: "出库时间",
    newTrack: "最新轨迹",
    dingdanxiangqing: "详情",
    jushou: "拒收",
    peihuo: "配货图片",
  },
  EN: {
    //英文翻译
    addGUOnei: "Add domestic express order No",
    shuru: "Please separate multiple order numbers with commas (,) spaces or line breaks",
    zidong: "The system will automatically remove duplicates or spaces",
    qing: "Empty",
    add: "Add",
    addRe: "Add notes",
    qingshuru: "Please enter comments",
    qudiao: "Remove excess packaging",
    baoliu: "Keep the original packaging",
    haopin: "Remove the package",
    jiyun: " Transportation",
    yijiyun: "Transported",
    qingbaoguo: "Please enter the package number",
    allPa: "AllPackage",
    TObe: "NotSigned",
    yiruku: "Signed",
    overduePackage: "OverduePackage",
    addTime: "Add time",
    beizhu: "remarks",
    xuanz: "Selected",
    bg: "package",
    gos: "goTransport",
    dingdan: "My order",
    qdanhao: "Please enter the order number",
    daidab: "ToBePacked",
    DZF: "ToBePaid",
    YZF: "PayTime",
    YCK: "DeliveryTime",
    YQS: "SigningTime",
    nonum: "No data",
    orders: "Order",
    zhuan: "Transfer",
    zhong: "weight",
    zongzhong: "weight",
    xiubeizhu: "note(M)",
    guojia: "country",
    yunshu: "transport",
    jiage: "Price",
    shijian: "time",
    zhiF: "To pay",
    zhuandanhao: "Transfer number",
    jifeiyong: "Billweight",
    chukushijian: "stocktime",
    newTrack: "latesttrack",
    quxiaodingdan: "Cancel",
    peihuo: "picture",
    dingdanxiangqing: "Detail",
    jushou: "Rejection",
  },
};
export default info;
